import React, { FC } from 'react';
import { useHttpQuery } from '@/api';
import { API_URLS } from '../../consts';

interface FriendsActivityProps {
  userID: string;
}

export const friendsActivityLabel = (count: number) =>
  count === 1
    ? '1 of your friends played today'
    : `${count} of your friends played today`;

export const FriendsActivity: FC<FriendsActivityProps> = ({ userID }) => {
  const { data } = useHttpQuery<{ count: number }>(
    ['friendsActivity', userID].join('-'),
    API_URLS.FRIENDS_ACTIVITY,
    'GET'
  );

  if (!data || data.count === 0) return null;

  return (
    <p className="bh-banner bh-banner--accent" style={{ margin: 0 }}>
      <span aria-hidden="true">🔥</span>
      <span>
        <strong>{friendsActivityLabel(data.count)}.</strong>{' '}
        <span className="bh-muted">Deal them in.</span>
      </span>
    </p>
  );
};
